import { TFunction } from 'i18next'

export const getInitialConcepts = (t: TFunction) => [{ key: 'none', value: 'None', text: t('global.nofilters') }]
